import React from 'react'

const FandD = () => {
    return (
        <div className='container'>
            <div className='container'>
                <h1>C function</h1>
                <p>In c, we can divide a large program into the basic building blocks known as function.
                The function contains the set of programming statements enclosed by { }. A function
                can be called multiple times to provide reusability and modularity to the C program.
                In other words, we can say that the collection of functions creates a program. The
                function is also known as procedureor subroutinein other programming languages.</p>
                <h3 style={{ margin: 20 }}>Advantage of functions in C</h3>
                <p>
                    There are the following advantages of C functions.
                <ol>
                        <li>
                            By using functions, we can avoid rewriting same logic/code again and again in a program.
                    </li>
                        <li>We can call C functions any number of times in a program and from any place in a program.</li>
                        <li>We can track a large C program easily when it is divided into multiple functions.</li>
                        <li>Reusability is the main achievement of C functions.</li>
                        <li>However, Function calling is always a overhead in a C program.</li>
                    </ol>
                    <h3>Types of Functions</h3>
                    <p>There are two types of functions in C programming:</p>
                    <ol>
                        <li> <b>Library Functions:</b> are the functions which are declared in the C header files such as scanf(), printf(), gets(), puts(), ceil(), floor() etc.</li>
                        <li> <b> User-defined functions:</b> are the functions which are created by the C programmer, so that he/she can use it many times. It reduces the complexity of a big program and optimizes the code.
</li>

                    </ol>
                    <h3>Return Value</h3>
                    <p>A C function may or may not return a value from the function. If you don't have to return any value from the function, use void for the return type. <br /><br />
                Let's see a simple example of C function that doesn't return any value from the function. <br />
                        <div className='containers'>
                            <code className='keyword'>void </code> hello()&#123; <br />
                            <code className='library'> printf </code> ("Hello, NooB-Geeks!");<br />
                  &#125;
                </div>
                    </p>
                </p>
                <p>If you want to return any value from the function, you need to use any data type such as int, long, char, etc. The return type depends on the value to be returned from the function.

Let's see a simple example of C function that returns int value from the function.</p>
                <div className='containers'>
                    <code className='keyword'>int </code> get()&#123; <br />
                    <code className='library'> return </code> 10;<br />
                  &#125;
                </div>
            </div>
            <h3>Different aspects of function calling</h3>
            <p>A function may or may not accept any argument. It may or may not return any value. Based on these facts, There are four different aspects of function calls.</p>
            <ol>
                <li>function without arguments and without return value</li>
                <li>function without arguments and with return value</li>
                <li>function with arguments and without return value</li>
                <li>function with arguments and with return value</li>
            </ol>
            <h3>Example for Function without argument and return value</h3>
            <div className='container'>
                <div className='containers'>
                    <code class="library">#include &lt;stdio.h&gt;</code> <br />
                    <code className='keywords'>void</code> printName()<br />
                    <code>&#123;	</code><br />
                    <code>printf("NooB-Geeks"); <br /> </code>
           &#125; <br />
                    <code className='keywords'>int</code> main() &#123;<br />

                    <code className='library'> printf </code> ("Hello,");<br />
           printName(); <br />

                    <code>return 0; <br /> &#125;</code><br />

                </div>
                <code className='output'>Output: Hello,NooB-Geeks</code>
            </div> 
            <br /> <br />
             <h3>Example for Function without argument and with return value</h3>
            <div className='container'>
                <div className='containers'>
                    <code class="library">#include &lt;stdio.h&gt;</code> <br />
                    <code className='keywords'>int</code> sum( )<br />
                    
                    <code>&#123;</code><br />
                    <code className='keywords'>int {' '}</code>a,<code className='keywords'>int{' '}</code>b <br />
                    <code className='library'> printf</code>("\nEnter two numbers");  <br />
                    <code className='library'> scanf</code>("%d %d",&a,&b); <br />
                    <code className='library'> return</code> a+b <br />
           &#125; <br />
                    <code className='keywords'>int</code> main() &#123;<br />
                    <code className='keywords'>int </code> {' '}result <br />
                    <code className='library'> printf</code> ("\nGoing to calculate the sum of two numbers:");   <br /> 
                    result= sum();    <br /> 
                    <code className='library'> printf</code>("%d",result);       <br /> 
                    

                  &#125;<br />

                </div>
               
                <div className='output'>
                    Going to calculate the sum of two numbers: <br /><br />

Enter two numbers 10<br /> 24 <br /> <br />

The sum is 34</div>

            </div>
            <h3>Example for Function with argument and without return value</h3>
            <div className='container'>
                <div className='containers'>
                    <code class="library">#include &lt;stdio.h&gt;</code> <br />
                    <code className='keywords'>void</code> sum( <code className='keywords'>int {' '}</code>a,<code className='keywords'>int{' '}</code>b )<br />
                    <code>&#123;	</code><br />
                    <code className='library'> printf</code> ("\nThe sum is %d",a+b);   <br /> 
                   
           &#125; <br />
                    <code className='keywords'>int</code> main() &#123;<br />
                    <code className='keywords'>int </code>a,b,result;  <br />
                    <code className='library'> printf</code> ("\nGoing to calculate the sum of two numbers:");   <br /> 
                    <code className='library'> printf</code> ("\nEnter two numbers:");     <br /> 
                    <code className='library'> scanf</code>("%d %d",&a,&b);       <br /> 
                    sum(a,b);  <br />

                    <code>return 0; <br /> &#125;</code><br />

                </div>
                
                <div className='output'>Going to calculate the sum of two numbers: <br /><br />

Enter two numbers 10<br /> 24 <br /> <br />

The sum is 34</div>

            </div>
            <h3>Example for Function with argument and with return value</h3>
            <div className='container'>
                <div className='containers'>
                    <code class="library">#include &lt;stdio.h&gt;</code> <br />
                    <code className='keywords'>int</code> sum( <code className='keywords'>int {' '}</code>a,<code className='keywords'>int{' '}</code>b )<br />
                    <code>&#123;	</code><br />
                    <code className='library'> return</code>{' '} a+b;   <br /> 
                   
           &#125; <br />
                    <code className='keywords'>int</code> main() &#123;<br />
                    <code className='keywords'>int </code>a,b,result;  <br />
                    <code className='library'> printf</code> ("\nGoing to calculate the sum of two numbers:");   <br /> 
                    <code className='library'> printf</code> ("\nEnter two numbers:");     <br /> 
                    <code className='library'> scanf</code>("%d %d",&a,&b);       <br /> 
                    sum(a,b);  <br />

                    <code>return 0; <br /> &#125;</code><br />

                </div>
                
                <div className='output'>Going to calculate the sum of two numbers: <br /><br />

Enter two numbers 10<br /> 24 <br /> <br />

The sum is 34</div>

            </div>
            </div>
    )
}

export default FandD
